<template>
	<div>
		<Header />
		<uploadData />
		<navigation />
		<div class="information major-income">
			<div>
				<p class="moduleName">
					<img src="../../assets/img/navIcon/financeSele.png" alt="心流">
					<span>{{this.$route.query.type==5?this.$route.query.year+'年财务指标':'财务指标'}}</span>
					<span v-if="this.$route.query.type==2" class="division">|</span>
					<span v-if="this.$route.query.type==2" class="">专业估值</span>
				</p>
				<!-- <div v-if="this.$route.query.type==2" class="down-up-container">
					<a href="/data/财务报表模板.xlsx" class="down-container">下载模板</a>
					<span class="up-container" @click="uploadInformation">
						<font>上传信息表</font>
					</span>
				</div> -->
			</div>

			<Modal v-model="myAlert" class-name="vertical-center-modal uploadFiles" :mask-closable="false">
				<p slot="header">
					<em></em>
					<span>上传文件</span>
				</p>
				<div class="file-container">
					<span class="up-container">
						<input type="file" name="file" id="fileupload" ref="file" @change="uploadFiles($event)">
						<font>上传信息表</font>
					</span>
					<p class="up-file">支持excel格式文件，填写财务数据时，<span class="red">请勿使用剪切（Ctrl+X）功能</span>，会导致表格公式出现错误。</p>
				</div>
				<div slot="footer"></div>
			</Modal>
			<Modal v-model="success" class-name="vertical-center-modal file_uccess" :mask-closable="false">
				<p slot="header">
					<em></em>
					<span>上传文件</span>
				</p>
				<div class="file-container">
					<img src="../../assets/img/up-success@2x.png">
					<p>报表上传成功，请再次确定财务信息！</p>
				</div>
				<div slot="footer" class="ivu-sure" @click="submitDialog">确定</div>
			</Modal>

			<Modal v-model="error" class-name="vertical-center-modal" :mask-closable="false">
				<img class='warning' src="../../assets/img/remind-01@2x.png">
				<span>您选择的模板有误，请上传心流网提供的专业模板</span>
				<div slot="footer" class="ivu-sure" @click="wrongBtn">确定</div>
			</Modal>

			<div class="moduleMain">
				<financeNav />
				<div class="inputTabDesc">
					<p class="table-desc-tit">
						<img src="../../assets/img/guzhi/desc@2x.png" alt="营业收入预测表的填表说明-心流" />
						<span>填表说明</span>
					</p>
					<ul v-if="type!=2">
						<li>
							<span>1、此表为企业未来年度收入预测表，建议按照实际业务分类或产品分类填报。</span>
						</li>
						<li>
							<span>2、此表为选填表，请按照实际情况尽量填写，填报情况将影响到估值结果的准确性。</span>
						</li>
						<li>
							<span>3、如果收入很难分类，或收入结构比较单一，可以填报一个数据。</span>
						</li>
					</ul>
					<ul v-else>
						<li>
							<span>此表为企业未来年度收入预测表，请按照实际情况尽量填写，填报情况将影响到估值结果的准确性。</span>
						</li>
					</ul>
				</div>
				<div class="table-main">
					<!-- 表名-->
					<div class="table-name">
						<span>营业收入分析预测表</span>
					</div>
					<span class="unit">单位：元</span>
					<div class="table-container">
						<table class="table" border="0" style="border-collapse: collapse;">
							<thead>
								<tr>
									<th>{{yearList[0]}}</th>
									<th v-for="(item, index) in yearList.slice(1,yearList.length)">{{type==2?item.replace('年','E'):item}}
									</th>
									<th v-if="this.$route.query.type!=2"></th>
								</tr>
							</thead>
							<tbody v-if="this.$route.query.type!=2">
								<tr v-for="(operation,index) in incomeJson.products">
									<td v-for="(item, i) in operation">
										<input type="text" v-if="i==0" v-model="operation[i]" @blur="sensitiveWordBlur($event,index)" />
										<input type="number" data-type="number" v-if="i!=0" v-model="operation[i]"
											@blur="blur($event,'products',i,index)" ref="forbid" />
										<span class="showInput" v-if="i!=0" @click="inputFocus($event)">
											{{judgingCondition('products',i,index)?formatCurrency.formateNum(incomeJson.products[index][i],2):'-'}}
										</span>
									</td>
									<td><input class="delete" type="button" value="删除" @click="del($event,index)"
											:disabled="status==1?true:false" /></td>
								</tr>
								<tr>
									<td colspan="8"><input class="add" type="button" value="添加" @click="add"
											:disabled="status==1?true:false" /></td>
								</tr>
								<tr>
									<td v-for="(item, i) in incomeJson.productOther">
										<div v-if="i==0">其他</div>
										<input type="number" data-type="number" v-if="i!=0" v-model="incomeJson.productOther[i]"
											@blur="blur($event,'productOther',i)" ref="forbid" />
										<span class="showInput" v-if="i!=0" @click="inputFocus($event)">
											{{judgingCondition('productOther',i)?formatCurrency.formateNum(incomeJson.productOther[i],2):'-'}}
										</span>
									</td>
								</tr>
								<tr>
									<td v-for="(item, i) in incomeJson.productSum">
										<div v-if="i==0">合计</div>
										<input type="number" data-type="number" v-if="i!=0" v-model="incomeJson.productSum[i]" disabled />
										<span class="showInput" v-if="i!=0">
											{{judgingCondition('productSum',i)?formatCurrency.formateNum(incomeJson.productSum[i],2):'-'}}
										</span>
									</td>
								</tr>
							</tbody>
							<tbody v-else>
								<tr>
									<td v-for="(item, i) in incomeJson.productSum">
										<div v-if="i==0">主营业务收入</div>
										<input type="number" data-type="number" v-if="i!=0" v-model="incomeJson.productSum[i]"
											@blur="blur($event,'productSum',i)" ref="forbid" />
										<span class="showInput" v-if="i!=0" @click="inputFocus($event)">
											{{judgingCondition('productSum',i)?formatCurrency.formateNum(incomeJson.productSum[i],2):'-'}}
										</span>
									</td>
								</tr>
							</tbody>


						</table>
					</div>

					<div class="mobileIncome">
						<ul>
							<li v-for="(operation,index) in incomeJson.products">
								<div v-for="(item, i) in operation">
									<p>{{yearList[i]}}</p>
									<input type="text" v-if="i==0" v-model="operation[i]" @blur="sensitiveWordBlur($event,index)" />
									<input class="delete" type="button" v-if="i==0" value="删除" @click="del($event,index)"
										:disabled="status==1?true:false" />

									<div>
										<input type="number" data-type="number" v-if="i!=0" v-model="operation[i]"
											@blur="blur($event,'products',i,index)" ref="forbid" />
										<span class="showInput" v-if="i!=0" @click="inputFocus($event)">
											{{judgingCondition('products',i,index)?formatCurrency.formateNum(incomeJson.products[index][i],2):'-'}}
										</span>
									</div>
								</div>
							</li>
							<li v-if="type!=2">
								<div>
									<input class="add" type="button" value="添加" @click="add" :disabled="status==1?true:false" />
								</div>
							</li>
							<li>
								<div v-for="(item, i) in incomeJson.productOther">
									<p v-if="i==0">其他</p>
									<p v-if="i!=0">{{yearList[i]}}</p>
									<div>
										<input type="number" data-type="number" v-if="i!=0" v-model="incomeJson.productOther[i]"
											@blur="blur($event,'productOther',i)" ref="forbid" />
										<span class="showInput" v-if="i!=0" @click="inputFocus($event)">
											{{judgingCondition('productOther',i)?formatCurrency.formateNum(incomeJson.productOther[i],2):'-'}}
										</span>
									</div>
								</div>
							</li>
							<li v-if="type!=2">
								<div v-for="(item, i) in incomeJson.productSum">
									<p v-if="i==0">合计</p>
									<p v-if="i!=0">{{yearList[i]}}</p>
									<div>
										<input type="number" data-type="number" v-if="i!=0" v-model="incomeJson.productSum[i]" disabled />
										<span class="showInput" v-if="i!=0">
											{{judgingCondition('productSum',i)?formatCurrency.formateNum(incomeJson.productSum[i],2):'-'}}
										</span>
									</div>
								</div>
							</li>
							<li v-else>
								<div v-for="(item, i) in incomeJson.productSum">
									<p v-if="i==0">主营业务收入</p>
									<p v-if="i!=0">{{yearList[i].replace('年','E')}}</p>
									<div>
										<input type="number" data-type="number" v-if="i!=0" v-model="incomeJson.productSum[i]"
											@blur="blur($event,'productSum',i)" ref="forbid" />
										<span class="showInput" v-if="i!=0" @click="inputFocus($event)">
											{{judgingCondition('productSum',i)?formatCurrency.formateNum(incomeJson.productSum[i],2):'-'}}
										</span>
									</div>
								</div>
							</li>
						</ul>

					</div>

					<span class="tipRed">提示：<span class="year"></span>年营业收入预测等于基本信息中公司营业收入（预测）</span>
					<div class="tableXian"></div>
				</div>
			</div>

			<div class="saveBox">
				<span class="last lastStep" @click="lastStep">上一步</span>
				<span class="save saveNext" id="saveButton" @click="saveButton">保 存</span>
			</div>

			<Modal v-model="sensitiveWord" class-name="vertical-center-modal" :mask-closable="false">
				<img class='warning' src="../../assets/img/remind-01@2x.png">
				<span>{{markedWords}}</span>
				<div slot="footer" class="ivu-sure" @click="sensitiveWordOk">确定</div>
			</Modal>

			<!-- 缓存提示框 -->
			<Modal v-model="cacheAlert" class-name="vertical-center-modal" :mask-closable="false"
				@on-cancel="clickCacheMaskJump">
				<img class='warning-cache' src="../../assets/img/caution.png">
				<span class="cache-title">您上次填写过估值报告，是否载入缓存信息？</span>
				<div slot="footer" class="ivu-no" @click="clickCacheTrueMaskJump">是</div>
				<div slot="footer" class="ivu-sure-cache" @click="clickCacheMaskJump">否</div>
			</Modal>
		</div>

		<Footer />
		<router-view />
	</div>
</template>

<script>
	import Header from '../header.vue';
	import Footer from '../footer.vue';
	import navigation from './navigation.vue';
	import uploadData from './uploadData.vue';
	import financeNav from './financeNav.vue';
	import qs from 'qs'
	import axios from 'axios';
	import {
		mapState,
		mapMutations
	} from 'vuex';

	export default {
		data() {
			return {
				type: this.$route.query.type,
				yearList: [],
				status: 2, // 判断当前页面是否可以修改  1代表不能修改   (1 审核通过  2 未填写完成  3 填写完成未支付)
				id: '',
				incomeJson: {
					productOther: ['other', '', '', '', '', '', ''],
					productSum: this.$route.query.type == 2 ? ['sum', '', '', ''] : ['sum', '', '', '', '', '', ''],
					products: [],
					year: []
				},
				baseInfoIncome: '',
				myAlert: false, //上传模板的弹框
				success: false, //上传模板成功的弹框
				error: false, //上传模板错误的弹框
				reportId: '',
				sensitiveWord: false,
				markedWords: '', //弹框提示语
				projectName: '',
				cacheAlert: false
			}
		},
		components: {
			Header,
			Footer,
			navigation,
			uploadData,
			financeNav
		},
		mounted() {
			if (this.$route.query.type == 7) {
				this.projectName = this.domain.diagnoseProject;
			} else if (this.$route.query.type == 5) {
				this.projectName = this.domain.traceProject;
			} else if (this.$route.query.type == 2) {
				this.projectName = this.domain.valuationProject;
			}
			this.pageModify('false');
			this.getOperatingReceipt()
		},
		updated() {
			if (this.status == 1) {
				document.querySelector('.uploading').setAttribute("class", "forbidden"); //禁止上传模板
				this.$refs.forbid.forEach((item, i) => {
					item.disabled = "true";
					item.style.backgroundColor = '#fff';
					item.nextSibling.style.backgroundColor = '#fff';
					item.nextSibling.style.pointerEvents = 'none';
				})
			} else {
				this.$refs.forbid.forEach((item, i) => {
					item.disabled = "";
				})
			}
		},
		methods: {
			...mapMutations(['pageModify']),
			judgingCondition: function(key, i, index) {
				if (key == 'products') {
					if (this.incomeJson[key][index][i] === 0) {
						return true
					} else if (this.incomeJson[key][index][i] != 0 && this.incomeJson[key][index][i] != '-') {
						return true
					} else {
						return false
					}
				} else {
					if (this.incomeJson[key][i] === 0) {
						return true
					} else if (this.incomeJson[key][i] != 0 && this.incomeJson[key][i] != '-') {
						return true
					} else {
						return false
					}
				}
			},
			sensitiveWordBlur: function(e, index) { //  index：products中第几个的下标
				this.pageModify('true');
				if (this.method.filterSensitiveWords(e.target, this.incomeJson.products[index], 'statement')) {
					e.currentTarget.style.borderColor = "red";
					this.sensitiveWord = true;
					this.markedWords = '您输入的内容存在敏感词';
				} else {
					e.currentTarget.style.borderColor = "#CACACA";
				}
			},
			blur: function(e, name, i, index) { //name：具体的科目名称  i：科目名称中自己所处的下标   index：products中第几个的下标
				this.pageModify('true');
				e.currentTarget.nextSibling.style.display = 'block';
				if (name == 'products') {
					var data = this.incomeJson[name][index];
				} else {
					var data = this.incomeJson[name];
				}
				var y = String(data[i]).indexOf("."); //获取小数点的位置
				var count = String(data[i]).length - y; //获取小数点后的个数
				var totalNum = 0;

				if (data[i]) {
					if (String(data[i]).indexOf(".") != -1) {
						this.$set(data, i, Math.round(Number(data[i]) * 100) / 100) //保留两位
					} else {
						if (data[i].length > 15) { //判断数据的合理性
							this.$Message.error({
								background: true,
								content: '请输入合理数据'
							});
							this.$set(data, i, '')
						} else {
							this.$set(data, i, Number(data[i]))
							if (this.type != 2) {
								for (var j = 0; j < this.incomeJson.products.length; j++) {
									totalNum += Number(this.incomeJson.products[j][i])
									this.incomeJson.productSum[i] = Number(totalNum) + Number(this.incomeJson.productOther[
										i])
								}
							}

						}
					}
				} else {
					this.$set(data, i, '')
					for (var j = 0; j < this.incomeJson.products.length; j++) {
						totalNum += Number(this.incomeJson.products[j][i])
						this.incomeJson.productSum[i] = Number(totalNum) + Number(this.incomeJson.productOther[
							i])
					}
				}


				//调用缓存共用方法
				if (this.$route.query.type == 7 || this.$route.query.type == 2) {
					if (!this.$route.query.reportId || (this.$route.query.reportId && !this.incomeContent) || (this
							.$route.query.reportId && this.incomeContent && this.isCacheValue == '0')) {
						this.method.caching("incomeJson", JSON.stringify(this.incomeJson), this.$route.query.type, this
							.$route.query.stage, this)
					}
				}
			},
			focus: function(e) {

			},
			inputFocus: function(e) {
				e.currentTarget.style.display = 'none';
				e.currentTarget.previousSibling.style.display = 'block';
				e.currentTarget.previousSibling.focus();
			},
			lastStep: function() {
				if (this.$route.query.reportId) {
					if (this.$route.query.type == 5) {
						this.$router.push({
							path: '/profitStatement',
							query: {
								stage: this.$route.query.stage,
								type: this.$route.query.type,
								reportId: this.$route.query.reportId,
								traceReportId: this.$route.query.traceReportId,
								year: this.$route.query.year
							}
						})
					} else {
						this.$router.push({
							path: '/profitStatement',
							query: {
								stage: this.$route.query.stage,
								type: this.$route.query.type,
								reportId: this.$route.query.reportId
							}
						})
					}
				} else {
					this.$router.push({
						path: '/profitStatement',
						query: {
							stage: this.$route.query.stage,
							type: this.$route.query.type
						}
					})
				}
			},
			getOperatingReceipt: function(close) {
				this.$Spin.show(); //全局加载中
				if (this.$route.query.type == 5) {
					var params = {
						reportId: this.$route.query.reportId,
						traceReportId: this.$route.query.traceReportId,
						year: this.$route.query.year
					}
				} else {
					var params = {
						reportId: this.$route.query.reportId ? this.$route.query.reportId : '',
						versions: sessionStorage.versions,
						stage: this.$route.query.stage,
						reportType: this.$route.query.type,
					}
				}
				this.$post(this.projectName + 'income/queryIncomeByReportId', qs.stringify(params))
					.then((res) => {
						this.$Spin.hide();
						if (this.$route.query.type == 5) {
							for (var i = 0; i < res.data.content.income.years.length; i++) {
								if (i == 3 || i == 4 || i == 5) {
									res.data.content.income.years[i] = res.data.content.income.years[i] + 'E';
								} else {
									res.data.content.income.years[i] = res.data.content.income.years[i] + '年';
								}
							}
							this.yearList = res.data.content.income.years;
							this.yearList.unshift('主营业务收入');
							this.incomeJson.year = res.data.content.income.years.slice(1, 7);
							this.status = res.data.content.traceRelation.status;
							this.id = res.data.content.income.id;
							if (res.data.content.income.income) {
								this.incomeJson = JSON.parse(res.data.content.income.income);
							} else {
								for (var i = 0; i < 2; i++) {
									this.incomeJson.products.push([])
									for (var j = 0; j < 7; j++) {
										this.incomeJson.products[i].push("")
									}
								}
							}
						} else {
							for (var i = 0; i < res.data.content.years.length; i++) {
								if (i == 3 || i == 4 || i == 5) {
									res.data.content.years[i] = res.data.content.years[i].replace("年", "E");
								}
							}
							this.yearList = res.data.content.years;
							this.incomeJson.year = res.data.content.years;

							this.yearList.unshift('项目');
							this.id = res.data.content.id;
							this.incomeContent = res.data.content.income;
							this.isCacheValue = res.data.content.isCache;
							this.baseInfoIncome = res.data.content.baseInfoIncome;
							if (this.isCacheValue == '0' && close == '0') {
								this.method.clearCaching(this.$route.query.type, this.$route.query.stage, this)
							}
							if (res.data.content.income) {
								// 缓存数据
								if (res.data.content.isCache == "0" && !sessionStorage.isHistoryCache) {
									this.cacheAlert = true;
									this.defaultData();
								} else { //正式数据
									this.incomeJson = JSON.parse(res.data.content.income);
								}
							} else {
								this.incomeJson.products = []
								for (var i = 0; i < 2; i++) {
									this.incomeJson.products.push([])
									for (var j = 0; j < 7; j++) {
										this.incomeJson.products[i].push("")
									}
								}

							}
						}
					})

			},
			defaultData: function() {
				var date = new Date;
				var year = date.getFullYear();
				this.yearList = ['主营业务收入', year - 3 + '年', year - 2 + '年', year - 1 + '年', year + 'E', year + 1 + 'E',
					year + 2 + 'E'
				];
				for (var i = 0; i < 2; i++) {
					this.incomeJson.products.push([])
					for (var j = 0; j < 7; j++) {
						this.incomeJson.products[i].push("")
					}
				}
			},
			saveButton: function() {
				if (this.status == 1) {
					this.$router.push({
						path: '/majorPolicyStatis',
						query: {
							stage: this.$route.query.stage,
							type: this.$route.query.type,
							reportId: this.$route.query.reportId,
							traceReportId: this.$route.query.traceReportId,
							year: this.$route.query.year
						}
					})
				} else {
					var incomeJson = {
						year: this.yearList.slice(1, 4),
						productSum: this.incomeJson.productSum
					}
					var params = {
						id: this.id,
						reportId: this.$route.query.reportId,
						incomeJson: this.type == 2 ? JSON.stringify(incomeJson) : JSON.stringify(this.incomeJson),
						stage: sessionStorage.stage
					}

					if (this.$route.query.type == 5) {
						params.traceReportId = this.$route.query.traceReportId;
						params.year = this.$route.query.year;
					} else {
						params.reportType = this.$route.query.type;
						params.versions = sessionStorage.versions;
					}

					console.log(params)

					if (this.type == 2) {
						if (this.baseInfoIncome != '' && this.incomeJson.productSum[1] != this.baseInfoIncome * 10000) {
							this.sensitiveWord = true;
							this.markedWords = this.yearList[1] + "营业收入预测的数据跟基本信息中营业收入预测（" + this.baseInfoIncome + "万元）不符";
							return
						}
					}

					this.$post(this.projectName + 'income/addIncome', qs.stringify(params))
						.then((res) => {
							if (res.data.code == 200) {
								if (this.$route.query.type == 5) {
									this.$router.push({
										path: '/majorPolicyStatis',
										query: {
											stage: this.$route.query.stage,
											type: this.$route.query.type,
											reportId: this.$route.query.reportId,
											traceReportId: this.$route.query.traceReportId,
											year: this.$route.query.year
										}
									})
								} else {
									this.$router.push({
										path: '/majorPolicyStatis',
										query: {
											stage: this.$route.query.stage,
											type: this.$route.query.type,
											reportId: JSON.parse(res.data.content).reportId
										}
									})
								}
							}
						});
				}
			},
			del: function(e, index) {
				var this_ = this;
				this.incomeJson.products[index].forEach(function(item, i) {
					if (i != 0) {
						this_.incomeJson.productSum[i] = this_.incomeJson.productSum[i] - item;
					}
				})
				this.incomeJson.products.splice(index, 1)
			},
			add: function() {
				this.incomeJson.products.push(['', '', '', '', '', '', ''])
			},
			uploadInformation: function() {
				this.myAlert = true;
			},
			uploadFiles: function(e) {
				var formData = new FormData();
				formData.append("file", e.target.files[0]);
				formData.append('reportId', this.$route.query.reportId ? this.$route.query.reportId : '');
				formData.append("stage", sessionStorage.getItem("stage"));
				if (sessionStorage.reportType == 7) {
					formData.append("reportType", sessionStorage.getItem("reportType"));
				}
				formData.append("versions", sessionStorage.getItem("versions") ? sessionStorage.getItem("versions") :
					1);
				this.$post(this.projectName + 'upload/uploadFile', formData)
					.then((res) => {
						if (res.data.code == 200) {
							this.myAlert = false;
							this.reportId = res.data.content;
							if (res.data.content != "非法的excel" && res.data.content != "模板已更新，请重新下载最新模板再上传！") {
								this.success = true;
							} else if (res.data.content == "非法的excel") {
								this.error = true;
							}
						}
					})
			},
			submitDialog: function() {
				this.success = false;
				this.$router.push({
					path: '/majorIncomeAnalysis',
					query: {
						stage: sessionStorage.stage,
						type: sessionStorage.reportType,
						reportId: this.reportId
					}
				})
				this.$router.go(0)
			},
			wrongBtn: function() {
				this.error = false;
			},
			sensitiveWordOk: function() {
				this.sensitiveWord = false;
			},

			//是  载入缓存
			clickCacheTrueMaskJump() {
				sessionStorage.isHistoryCache = 1;
				this.cacheAlert = false;
				this.getOperatingReceipt();
			},

			//否  载入缓存
			clickCacheMaskJump() {
				sessionStorage.isHistoryCache = 1;
				this.cacheAlert = false;
				this.method.clearCaching(this.$route.query.type, this.$route.query.stage, this, 'getOperatingReceipt')
			}
		}

	}
</script>

<style scoped>
	table>tbody>tr.handle>td:last-child input {
		display: inline-block !important;
		margin-left: 15px;
	}

	table>tbody>tr.handle>td:last-child span.showInput {
		margin-right: 3%;
	}

	.mobileIncome {
		display: none;
	}

	@media screen and (max-width: 750px) {

		.inputTabDesc,
		.table-container,
		.tableXian,
		.down-up-container {
			display: none;
		}

		.mobileIncome {
			display: block;
		}

		div.table-name>span {
			font-size: 16PX;
		}

		span.unit {
			font-size: 12PX;
		}

		.mobileIncome ul>li>div:nth-child(n+2) {
			display: inline-block;
			margin-right: 15px;
			position: relative;
		}

		.mobileIncome ul>li>div:nth-child(n+2) p {
			margin: 5px 0;
		}

		.mobileIncome ul>li>div>div {
			margin: 10px 0;
			position: relative;
		}

		.mobileIncome ul>li>div input {
			width: 140px;
			height: 45px;
			line-height: 45px;
			color: #282828;
			display: block;
			border: 1px solid #D5D5D5;
			text-align: right;
			padding-right: 8px;
			font-size: 14PX;
		}

		.mobileIncome ul>li>div:first-child input {
			text-align: left;
			display: inline-block;
		}

		.mobileIncome span.showInput {
			width: 134px;
			height: 40px;
			line-height: 45px;
			font-size: 14PX;
			background: #fff;
			position: absolute;
			top: 2px;
			left: 3px;
			text-align: right;
		}

		.mobileIncome ul>li>div:first-child input.add {
			margin: 15px auto;
			text-align: center;
			border-color: #4393FF;
			color: #4393FF;
			background: #fff;
			display: block;
		}

		.mobileIncome ul>li>div:first-child input.delete {
			margin-left: 30%;
			margin-top: 10px;
			background: #fff;
			border-color: #FFA14C;
			color: #FFA14C;
			text-align: center;
		}


	}
</style>